// Component
import AppFetcher from './AppFetcher';
import { connect } from 'react-redux';

// Libs
export default connect(state => {
  return {
    authentication: state.authentication,
    authStatus: state.authentication.status,
    clientStatus: state.client.status, // TODO Jules: convert this fetch into latest resift fetch format
    siftBotStatus: state.siftBot.status, // TODO Jules: convert this fetch into latest resift fetch format
  };
})(AppFetcher);
